import { isMobile, getDeviceSource } from './mobile-detection'
import { DeviceSources } from './mobile-detection-types'

export default {
  isMobile,
  getDeviceSource,
  DeviceSources
}
